<template>
  <div class="control-content__label">
    {{ label }}
  </div>  
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    label: {
      type: String,
      required: true,
    },
  },
})
export default class TextLabel extends Vue {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/search/TextLabel.vue